import { render, staticRenderFns } from "./UserBackend.vue?vue&type=template&id=447c92e7&scoped=true&"
import script from "./UserBackend.vue?vue&type=script&lang=js&"
export * from "./UserBackend.vue?vue&type=script&lang=js&"
import style0 from "./UserBackend.vue?vue&type=style&index=0&id=447c92e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447c92e7",
  null
  
)

export default component.exports